<template>
  <v-row class="ma-0 pa-0">
    <v-col cols="12" class="pa-0 ma-0">
      <v-tabs v-model="tab" centered grow>
        <v-tab href="#asignacion_adendas" @click="actualizarItems('asignacion_adendas')">
          Asignación de Tipo de Adendas
        </v-tab>
        <v-tab href="#gestion_adendas" @click="actualizarItems('gestion_adendas')">
          Gestión de Adendas
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item value="asignacion_adendas">
          <AsignacionAdendas ref="asignacion_adendas" />
        </v-tab-item>
        <v-tab-item value="gestion_adendas">
          <GestionAdendas ref="gestion_adendas" />
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import AsignacionAdendas from './Adendas/AsignacionAdendas.vue'
import GestionAdendas from './Adendas/GestionAdendas.vue'

export default {
  components: { AsignacionAdendas, GestionAdendas },
  data: () => ({ tab: 'asignacion_adendas' }),
  methods: {
    getItems () {
      this.actualizarItems(this.tab)
    },
    actualizarItems (refName) {
      const vista = this.$refs[refName]
      if (vista && typeof vista.getItems === 'function') vista.getItems()
    }
  }
}
</script>
